/**
 * The words on /delete-account.
 *
 * Same honesty rule as the rest of the repo: every line describes what
 * emo_users/account_deletion.py actually does. If that endpoint's behaviour changes, change these
 * sentences in the same commit — a page that overstates a deletion is worse than no page.
 */
export const DELETE_TITLE = "Delete your account";

export const DELETE_INTRO =
  "This removes your CherryClipz account and everything in it. It happens straight away and it cannot be undone.";

export const DELETE_GONE_HEADING = "What goes";
export const DELETE_GONE = [
  "Your account and your email address.",
  "Every video you uploaded, and the files behind them.",
  "Every transcript, clip, speaker and score made from them.",
  "Every export you created, and any share links pointing at them.",
  "Your subscription, cancelled at the same moment, so you are not charged again.",
];

export const DELETE_KEPT_HEADING = "What we keep";
export const DELETE_KEPT = [
  "Payment records Stripe holds for tax and accounting. We cannot delete those, and neither can they.",
  "Ordinary server logs, which age out on their own.",
  "Nothing else. There is no archived copy waiting to be restored.",
];

export const DELETE_CONFIRM_LABEL = "Type the email address on the account";

export const DELETE_BUTTON = "Delete my account";
export const DELETE_WORKING = "Deleting…";

export const DELETE_DONE = {
  heading: "It is done.",
  paragraphs: [
    "Your account and everything in it have been deleted, and you are signed out on this device.",
    "If you had the app on a phone, you can delete it now — there is nothing left for it to open.",
  ],
};

export const DELETE_SIGNED_OUT =
  "Sign in first, then come back to this page. If you cannot sign in, email us and we will delete it for you.";

export const DELETE_BY_EMAIL = "Cannot sign in? Ask us to delete it:";
